<script>
import mainApi from "@/tools/MainApi";

const checker = async (getPageID) => await mainApi.post('api/client/permission/',
    {
        "pageID": getPageID
    })
    .then(response => {
        if(response.data.status === 80) {
            if (response.data.details.read === 1) {
                return {
                    "status": 80,
                    "details": response.data.details
                }
            } else {
                return {
                    "status": 0,
                }
            }
        }if(response.data.status === 1){
            return {
                "status": 0,
            }
        }else{
            Swal.fire({
                title: response.data.errors,
                text: response.data.details,
                icon: "error"
            })
            return {
                "status": 0,
            }
        }
    })

export default checker

</script>

